import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getPageLayout = get('settings.components.pageLayout');

export const getSidebarNavExpanded = createSelector(
  getPageLayout,
  get('sidebarNavExpanded')
);
